import { lodash } from '../../assets/js/helpers';

// import DataController from '../../assets/js/controllers/data';
import SessionController from '../../assets/js/controllers/session';

import projectListItemTemplate from '../../../dist/modules/project-list/item.html';


export default class ProjectList {

	static selector = 'project-list';

	data = null;

	constructor(container) {
		this.el = {
			container,
			list: container.querySelector('ul')
		};

		this.fetchList()
			.then(() => {
				this.renderList();
				this.gatherItems();
				this.addEventListeners();
			})
			.catch(() => {});
	}

	fetchList() {
		return new Promise((resolve, reject) => {
			fetch('/api/projects', {
					method: 'GET',
					headers: {
						'Session-Token': sessionStorage.getItem(SessionController.keys.sessionToken)
					}
				})
				.then(response => (response.status === 200 ? response.json() : {}))
				.then((result) => {
					this.data = result.data;
					this.data ? resolve() : reject();
				})
				.catch(reject);
		});
	}

	renderList() {
		for (const d of this.data) this.el.list.innerHTML += lodash.template(projectListItemTemplate)(d);
		this.el.container.append(this.el.list);
	}

	gatherItems() {
		this.el.items = {};
		const items = this.el.container.querySelectorAll('li[data-key]');
		for (const i of items) {
			this.el.items[i.dataset.key] = {
				li: i,
				tabTrigger: i.querySelectorAll(`.${this.constructor.selector}-item__tab-trigger button`),
				tabContent: i.querySelectorAll(`.${this.constructor.selector}-item__tab-content > div`),
				openCMS: i.querySelectorAll(`.${this.constructor.selector}-item__open-cms`),
				inlinePassword: i.querySelectorAll(`.${this.constructor.selector}-item__inline-password`)
			};
		}
	}

	#onTabTriggerClick = (e) => {
		e.preventDefault();
		const el = e.currentTarget;
		const { key } = el.closest('li[data-key]').dataset;
		const build = !el.classList.contains('is-active') ? el.dataset.build : null;
		for (const tt of this.el.items[key].tabTrigger) tt.classList[tt.dataset.build === build ? 'add' : 'remove']('is-active');
		for (const tc of this.el.items[key].tabContent) tc.classList[tc.dataset.build === build ? 'add' : 'remove']('is-active');
		for (const ip of this.el.items[key].inlinePassword) {
			ip.querySelector('input').value = '';
			ip.classList.remove('is-visible');
		}
	};

	#onOpenCMSClick = (e) => {
		e.preventDefault();
		const el = e.currentTarget;
		const li = el.closest('li[data-key]');
		const { build } = el.closest('div[data-build]').dataset;
		el.setAttribute('disabled', true);
		fetch(`/api/login/token?project=${li.dataset.key}&build=${build}`, {
				method: 'GET',
				headers: {
					'Session-Token': sessionStorage.getItem(SessionController.keys.sessionToken)
				}
			})
			.then(response => response.json())
			.then((result) => {
				// TODO allow popup!
				const { code } = result.status;
				if (code === 200) {
					let { url } = el.dataset;
					if (li.dataset.cmsType === 'craft-cms') url += `/autologin?key=${result.data.token}&cp=true`;
					li.classList.add('is-unlocked');
					setTimeout(() => {
						window.open(url, '_blank');
						li.classList.remove('is-unlocked');
					}, 500);
				} else {
					location.reload();
				}
			})
			.finally(() => {
				el.removeAttribute('disabled');
			});
	};

	addEventListeners() {
		for (const item in this.el.items) {
			for (const tt of this.el.items[item].tabTrigger) tt.addEventListener('click', this.#onTabTriggerClick);
			for (const oc of this.el.items[item].openCMS) oc.addEventListener('click', this.#onOpenCMSClick);
		}
	}

	removeEventListeners() {
		for (const item in this.el.items) {
			for (const tt of this.el.items[item].tabTrigger) tt.removeEventListener('click', this.#onTabTriggerClick);
			for (const oc of this.el.items[item].openCMS) oc.removeEventListener('click', this.#onOpenCMSClick);
		}
	}

	destroy() {
		this.removeEventListeners();
	}

}
